export function showIf(judgement, vnode, def) {
  return judgement ? vnode : def || "";
}
flarum.reg.add('xypp-store', 'forum/utils/NodeUtil', { showIf: showIf, });